<template>
  <div style="width:100%;overflow-y:auto;overflow-x:hidden;height:100%;">
    <div style="padding:20px;width:100%;">
      <div style="width:260px;float: left; padding: 20px;" class="whiteBox searchbox">
        <h4><i class="el-icon-d-arrow-right"></i> 筛选条件</h4>
        <div class="filter-container search-box">
          <el-form label-position="top" label-width="80px">
            <el-form-item label="搜索">
              <el-input
                size="mini"
                style="width:220px;top:2px;"
                placeholder="姓名或手机号码"
                v-model="searchQuery.key"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="创建时间">
              <el-date-picker
                v-model="searchQuery.dateRange1"
                type="daterange"
                size="mini"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="datePickerOption"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="订单审核时间">
              <el-date-picker
                v-model="searchQuery.dateRange2"
                type="daterange"
                size="mini"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="datePickerOption"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="订单退订时间">
              <el-date-picker
                v-model="searchQuery.dateRange3"
                type="daterange"
                size="mini"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="datePickerOption"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="订单取消时间">
              <el-date-picker
                v-model="searchQuery.dateRange4"
                type="daterange"
                size="mini"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="datePickerOption"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="线索来源">
              <el-select
                size="mini"
                style="width:180px;"
                v-model="searchQuery.fromType"
              >
                <el-option label="全部" :value="0"></el-option>
                <el-option label="线上" :value="1"></el-option>
                <el-option label="线下" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="线下来源" v-if="searchQuery.fromType == 2">
              <el-select
                size="mini"
                style="width:180px;"
                v-model="searchQuery.fromSources"
                @change="fromSourceChange"
                ref="subject"
              >
                <el-option
                  v-for="item in fromSourceOptions"
                  :key="item.dataValue"
                  :label="item.dataDisplay"
                  :value="item.dataValue"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="线上来源" v-if="searchQuery.fromType == 1">
              <el-select
                size="mini"
                style="width:180px;"
                multiple
                v-model="searchQuery.onlineSource"
              >
                <el-option
                  v-for="item in importSourceOptions"
                  :key="item.dataName"
                  :label="item.dataDisplay"
                  :value="item.dataName"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="订单状态">
              <el-select
                size="mini"
                style="width:180px;"
                multiple
                v-model="searchQuery.orderStatus"
              >
                <el-option
                  v-for="item in orderStatusDics"
                  :key="item.dataValue"
                  :label="item.dataDisplay"
                  :value="item.dataValue"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户经理" v-if="members.length > 1">
              <el-select
                size="mini"
                style="width:180px;"
                multiple
                v-model="searchQuery.member"
              >
                <el-option
                  v-for="item in members"
                  :key="item.memberId"
                  :label="item.userName"
                  :value="item.memberId"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="购车类型">
              <el-select
                size="mini"
                style="width:180px;"
                multiple
                v-model="searchQuery.businessTypes"
              >
                <el-option
                  v-for="item in businessTypeOptions"
                  :key="item.dataValue"
                  :label="item.dataDisplay"
                  :value="item.dataValue"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="订购车型">
              <el-cascader
                size="mini"
                class="filter-item"
                style="width: 180px;"
                placeholder="选择订购车型"
                filterable
                collapse-tags
                :props="{ multiple: true }"
                clearable
                :show-all-levels="true"
                :options="carOptions"
                v-model="searchQuery.modelIds"
              >
              </el-cascader>
            </el-form-item>
            <!-- <el-form-item label="转他店交付">
              <el-select size="mini"
                         style="width:180px;"
                         v-model="searchQuery.isOther">
                <el-option label="全部"
                           :value="0"></el-option>
                <el-option label="是"
                           :value="1"></el-option>
                <el-option label="否"
                           :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="锐见报表统计">
              <el-select size="mini"
                         style="width:180px;"
                         v-model="searchQuery.isReport">
                <el-option label="全部"
                           :value="0"></el-option>
                <el-option label="是"
                           :value="1"></el-option>
                <el-option label="否"
                           :value="2"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="APP线上下订">
              <el-select
                size="mini"
                style="width:180px;"
                v-model="searchQuery.showAppOrders"
              >
                <el-option label="是" :value="1"></el-option>
                <el-option label="否" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="APP订单号">
              <el-input
                size="mini"
                style="width:220px;top:2px;"
                placeholder="请输入APP订单号"
                v-model="searchQuery.extOrderId"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="车辆状态">
              <el-select
                size="mini"
                multiple
                style="width:180px;"
                v-model="searchQuery.otdStatus"
              >
                <el-option
                  :label="item.dataDisplay"
                  v-for="(item, index) in odsStatusDics"
                  :key="index"
                  :value="item.dataName"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否推荐购车">
              <el-select
                size="mini"
                style="width:180px;"
                v-model="searchQuery.hasReferrer"
                @clear="listQuery.hasReferrer=null"
              >
                <el-option label="全部" :value="0"></el-option>
                <el-option label="是" :value="1"></el-option>
                <el-option label="否" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div style="margin-top:20px;">
            <el-button
              size="small"
              icon="el-icon-search"
              class="filter-item"
              @click="retrieveTables(false)"
              >筛选
            </el-button>
            <el-button
              size="small"
              icon="el-icon-refresh"
              class="filter-item"
              @click="reset"
              >重置</el-button
            >
          </div>
        </div>
      </div>
      <div
        style="margin-left: 320px; overflow:auto;margin-right:20px;"
      >
        <h1 class="page_title">订单列表</h1>
        <el-table :data="tableRecords" stripe v-loading="listLoading" style="margin: 10px 0;">
          <el-table-column align="left" label="创建时间" width="120">
            <template slot-scope="scope">{{
              scope.row.createdAt | parseTime("{y}-{m}-{d} {h}:{i}")
            }}</template>
          </el-table-column>
          <el-table-column align="left" label="客户姓名" min-width="140">
            <template slot-scope="scope">
              <span class="click_link" @click="toDetailPage(scope.row)">
                {{ `${scope.row.customerType === 1 ? scope.row.customerName : scope.row.companyName}${scope.row.customerPhone ? ` - ` : ""}` }}
                <Desensitize
                  v-if="scope.row.customerPhone"
                  :text="scope.row.customerPhone"
                  :userType="1"
                  :clearText="true"
                  :queryKey="scope.row.id"
                  :key="scope.row.id"
                />
              </span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="状态" width="80">
            <template slot-scope="scope">{{
              scope.row.status | statusFitter
            }}</template>
          </el-table-column>
          <el-table-column align="left" label="订购车型" min-width="180">
            <template slot-scope="scope">{{ scope.row.modelDisplay }}</template>
          </el-table-column>
          <el-table-column align="left" label="车辆状态" width="100">
            <template slot-scope="scope">{{ scope.row.otdStatus }}</template>
          </el-table-column>
          <el-table-column align="left" label="预计交车时间" width="160">
            <template slot-scope="scope"
              ><span v-if="scope.row.deliverDate != 0">{{
                scope.row.deliverDate | parseTime("{y}-{m}-{d}")
              }}</span></template
            >
          </el-table-column>
          <el-table-column align="left" label="客户经理" min-width="100">
            <template slot-scope="scope">{{ scope.row.ownerName }}</template>
          </el-table-column>
          <el-table-column align="left" label="订金" width="60">
            <template slot-scope="scope">{{ scope.row.paymentDown }}</template>
          </el-table-column>
          <el-table-column align="left" label="选装" min-width="80">
            <template slot-scope="scope">
              <span>{{ scope.row.optional || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="已购竞品品牌" min-width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.backCompetitionBrand || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="已购竞品车系" min-width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.backCompetitionSeries || '-' }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column align="left"
                           label="成交金额"
                           width="130">
            <template slot-scope="scope">{{scope.row.paymentDeal}}</template>
          </el-table-column> -->
          <el-table-column align="left" label="流量类型" min-width="150">
            <template slot-scope="scope">
              <span>{{ getFlowTypeName(scope.row.flowType) }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="APP订单号" min-width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.extOrderId || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="广告主ID" min-width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.advertiserId || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="广告主名称" min-width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.advertiserName || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="广告项目ID" min-width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.promotionId || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="广告项目名称" min-width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.promotionName || '-' }}</span>
            </template>
          </el-table-column>
          
        </el-table>
        <div class="pagination-container">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="listQuery.page"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="listQuery.limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Desensitize from "@/components/Desensitize/Desensitize.vue";
var order_vm;
export default {
  components: {
    Desensitize,
  },
  data() {
    order_vm = this;
    return {
      listLoading: false,
      dealer: this.$common.getLoginInfo().profile,
      user: this.$common.getUser(),
      isAdmin: this.$common.getAdmin(),
      // carOptions: [],
      searchQuery: {
        key: "",
        hasReferrer: 0,
        fromType: 0,
        dateRange1: null,
        dateRange2: null,
        dateRange3: null,
        dateRange4: null,
        member: [],
        fromSources: '',
        onlineSource: [],
        businessTypes: [],
        orderStatus: [],
        isOther: 0,
        isReport: 0,
        sortType: 0,
        showAppOrders: "",
        extOrderId: "",
        modelIds: [],
        otdStatus: [],
      },
      tableRecords: [],

      total: 0,
      listQuery: {
        page: 1,
        limit: 10,
      },

      datePickerOption: {
        firstDayOfWeek: 1,
        shortcuts: [
          {
            text: "今日",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "昨日",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 364);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },

      customerOrderOptions: [
        { dataDisplay: "全部", dataValue: 0 },
        { dataDisplay: "未到店", dataValue: 1 },
        { dataDisplay: "已到店", dataValue: 2 },
        { dataDisplay: "订车", dataValue: 3 },
        { dataDisplay: "成交", dataValue: 4 },
        { dataDisplay: "战败", dataValue: 5 },
        { dataDisplay: "休眠", dataValue: 6 },
      ],
      fromSourceOptions: [],
      importSourceOptions: [],
      businessTypeOptions: [],
      members: [],
      orderType: 0,
      customizationList: [],
      orderStatusDics: [],
      carOptions: [], // 订购车型
      odsStatusDics: [], //otd筛选数据源
      routerOrderId: null,
      flowTypeList: []
    };
  },
  // filters: {},
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      let form = from.path;
      if (
        form === "/approved" ||
        form === "/orderCancel" ||
        form === "/waitingSubmit" ||
        form === "/submitted" ||
        form === "/isCar" ||
        form === "/rejected" ||
        form === "/refundUnderReview" ||
        form === "/pendingRefund" ||
        form === "/backOrder"
      ) {
        try {
          var listFilters = JSON.parse(sessionStorage.getItem("listFilters3"));
          vm.searchQuery = listFilters.searchQuery;
          vm.total = listFilters.total;
          vm.listQuery = listFilters.listQuery;
        } catch (error) {
          console.log(error)
        }
      }
      if (to.query && to.query.orderId) {
        vm.routerOrderId = to.query.orderId
      } else {
        vm.routerOrderId = null
      }
      vm.getList();
    });
  },
  created() {
    var baseInfo = this.$common.getBaseInfo();
    this.fromSourceOptions = baseInfo.customerFromSources;
    this.importSourceOptions = baseInfo.importSources;
    this.businessTypeOptions = baseInfo.businessTypes;
    this.orderStatusDics = baseInfo.orderStatusDics;
    this.odsStatusDics = baseInfo.odsStatusDics;
    this.flowTypeList = baseInfo.flowType;
    this.retrieveMembers();
    this.getcustomizationList();
    this.retrieveCarOptions();
  },
  mounted() {},
  methods: {
    retrieveCarOptions() {
      var parent = this;
      this.$httpAuth
        .post("/v1/dealerRpc/vehicleJsonTree", {
          dealerId: this.dealer.dealerId,
        })
        .then(function(response) {
          parent.carOptions = response.data.data;
        });
    },
    fromSourceChange(val) {
      if (val == 99) {
        this.$refs.subject.blur();
      }
    },
    // 其他来源数据
    getcustomizationList() {
      // var that = this;
      this.$httpAuth
        .post("/v2/appDealerManagerService/sourceList", {
          dealerId: this.dealer.dealerId,
        })
        .then((res) => {
          this.customizationList = res.data.data;
        });
    },
    retrieveMembers() {
      var parent = this;
      this.$httpAuth;
      this.$httpAuth
        .post("/v1/dealerMemberRpc/managerMembers", {
          dealerId: this.dealer.dealerId,
        })
        .then(function(response) {
          parent.members = response.data.data;
          //   if (!parent.isAdmin) {
          //     parent.members.push({
          //       memberId: parent.dealer.userId,
          //       userName: parent.dealer.name,
          //     })
          //   }
        });
    },
    retrieveTables() {
      this.listQuery.page = 1;
      this.getList();
    },
    // 重置
    reset() {
      this.orderType = 0;
      this.searchQuery = {
        key: "",
        fromType: 0,
        hasReferrer: 0,
        dateRange1: null,
        dateRange2: null,
        dateRange3: null,
        dateRange4: null,
        member: [],
        fromSources: '',
        onlineSource: [],
        businessTypes: [],
        orderStatus: [],
        isOther: 0,
        isReport: 0,
        sortType: 0,
        showAppOrders: "",
        extOrderId: "",
        modelIds: [],
        otdStatus: [],
      };
      this.retrieveTables();
    },
    // 获取列表数据
    getList() {
      var parent = this;
      if (this.searchQuery.fromType == 1) {
        this.searchQuery.fromSources = '';
      } else if (this.searchQuery.fromType == 2) {
        this.searchQuery.onlineSource = [];
      } else {
        this.searchQuery.fromSources = '';
        this.searchQuery.onlineSource = [];
      }
      let params = {
        hasReferrer: this.searchQuery.hasReferrer,
        dealerId: this.dealer.dealerId,
        pageStart: (this.listQuery.page - 1) * this.listQuery.limit,
        pageCount: this.listQuery.limit,
        saleIds:
          this.searchQuery.member.length > 0
            ? this.searchQuery.member.join(",")
            : "",
        createdDate: {
          start:
            this.searchQuery.dateRange1 != null
              ? this.searchQuery.dateRange1[0]
              : "",
          end:
            this.searchQuery.dateRange1 != null
              ? this.searchQuery.dateRange1[1]
              : "",
        },
        approvedDate: {
          start:
            this.searchQuery.dateRange2 != null
              ? this.searchQuery.dateRange2[0]
              : "",
          end:
            this.searchQuery.dateRange2 != null
              ? this.searchQuery.dateRange2[1]
              : "",
        },
        backDate: {
          start:
            this.searchQuery.dateRange3 != null
              ? this.searchQuery.dateRange3[0]
              : "",
          end:
            this.searchQuery.dateRange3 != null
              ? this.searchQuery.dateRange3[1]
              : "",
        },
        cancelDate: {
          start:
            this.searchQuery.dateRange4 != null
              ? this.searchQuery.dateRange4[0]
              : "",
          end:
            this.searchQuery.dateRange4 != null
              ? this.searchQuery.dateRange4[1]
              : "",
        },
        key: this.searchQuery.key,
        fromType: this.searchQuery.fromType,
        fromSources: this.searchQuery.fromSources.toString(),
        onlineSources:
          this.searchQuery.onlineSource.length > 0
            ? this.searchQuery.onlineSource.join(",")
            : "",
        businessTypes:
          this.searchQuery.businessTypes.length > 0
            ? this.searchQuery.businessTypes.join(",")
            : "",
        orderStatus:
          this.searchQuery.orderStatus.length > 0
            ? this.searchQuery.orderStatus.join(",")
            : "",
        otdStatus:
          this.searchQuery.otdStatus.length > 0
            ? this.searchQuery.otdStatus.join(",")
            : "",
        isOther: this.searchQuery.isOther,
        isReport: this.searchQuery.isReport,
        sortType: this.searchQuery.sortType,
        showAppOrders:
          this.searchQuery.showAppOrders === ""
            ? 0
            : this.searchQuery.showAppOrders,
        extOrderId: this.searchQuery.extOrderId,
        modelIds:
          this.searchQuery.modelIds.length > 0
            ? this.searchQuery.modelIds.map((item) => item[1]).join(",")
            : "",
        // seriesId:
        //   this.searchQuery.modelIds.length > 0
        //     ? Number(this.searchQuery.modelId[0])
        //     : 0,
      };
      // 如果路由上存在订单id，需要用订单id做筛选，请求成功后清除
      if (this.routerOrderId) {
        params.orderId = Number(this.routerOrderId)
      }
      this.listLoading = true;
      this.$httpAuth
        .post("/v2/appCustomerService/orders", params)
        .then(function(response) {
          parent.listLoading = false;
          parent.tableRecords = response.data.data;
          parent.total = response.data.total;
        })
        .catch(() => {})
        .finally(() => {
          this.routerOrderId = null
        });
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    toDetailPage(item) {
      var listFilters = {
        searchQuery: this.searchQuery,
        sortType: this.sortType,
        total: this.total,
        listQuery: this.listQuery,
      };
      sessionStorage.setItem("listFilters3", JSON.stringify(listFilters));
      sessionStorage.setItem("form", "order");
      sessionStorage.setItem("type", null);
      switch (item.status) {
        case 1: // 待提交
          this.$router.push({
            path: "/waitingSubmit",
            query: { id: item.id },
          });
          break;
        case 2: // 已提交
          this.$router.push({ path: "/submitted", query: { id: item.id } });
          break;
        case 3: // 经理已审核
          this.$router.push({
            path: "/approved",
            query: { id: item.id },
          });
          break;
        case 4: // 已配车
          this.$router.push({
            path: "/isCar",
            query: { id: item.id },
          });
          break;
        case 6: // 订单已驳回
          this.$router.push({
            path: "/rejected",
            query: { id: item.id },
          });
          break;
        case 8: // 已取消
          this.$router.push({
            path: "/orderCancel",
            query: { id: item.id },
          });
          break;
        case 10: // 已交车
          this.$router.push({
            path: "/isCar",
            query: { id: item.id },
          });
          break;
        case 12: // 授权配车
          this.$router.push({
            path: "/approved",
            query: { id: item.id },
          });
          break;
        case 13: // 已退订
          this.$router.push({
            path: "/backOrder",
            query: { id: item.id },
          });
          break;
        case 16: // 退款申请审核中
          this.$router.push({
            path: "/refundUnderReview",
            query: { id: item.id },
          });
          break;
        case 18: // 待退款
          this.$router.push({
            path: "/pendingRefund",
            query: { id: item.id },
          });
          break;
        default:
          break;
      }
    },
    getFlowTypeName(flowType) {
      return this.flowTypeList?.find(item => item.dataValue == flowType)?.dataDisplay ?? ''
    },
  },
  filters: {
    statusFitter(val) {
      for (var i = 0; i < order_vm.orderStatusDics.length; i++) {
        var o = order_vm.orderStatusDics[i];
        if (o.dataValue == val) {
          return o.dataDisplay;
        }
      }
      return "";
    },
  },
};
</script>

<style>
.add-title {
  width: 100%;
  font-size: 14px;
  font-weight: 700;
  color: rgba(10, 18, 32, 0.64);
  letter-spacing: normal;
  margin-bottom: 15px;
  margin-top: 10px;
}
</style>
